import { connect } from "react-redux";
import ApprovedCase from "./ApprovedCase";
import { bindActionCreators } from "redux";
import {
    caseListRequest,
    carModelRequest,
    carVariantRequest,
    carBrandRequest,
    caseStatusUpdateRequest
} from "../../../../../services/redux/CarLoan/action";

const mapStateToProps = (state) => ({
    caseListResponse : state.CarLoan.caseListResponse,
    carBrandResponse : state.CarLoan.carBrandResponse,
    carModelResponse : state.CarLoan.carModelResponse,
    carVariantResponse : state.CarLoan.carVariantResponse,
    caseStatusUpdateResponse : state.CarLoan.caseStatusUpdateResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        caseListRequest,
        carBrandRequest,
        carModelRequest,
        carVariantRequest,
        caseStatusUpdateRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ApprovedCase);